// extracted by mini-css-extract-plugin
export default {"heading":"_7bxAvRLLKKrJhF4WSnUm1B","story":"_5XAAU57tIWBUHeeSUsvQtD","storyTitle":"_6HYPYoUiVRNIYSDP5GDshb","storyContent":"_7tqKhL9OO6hAhS7YUoe3wM"};